<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-container>
        <v-card
            class="mx-auto d-print-none"
            style="border: darkgreen 2px solid;background-color: linen"
        >
          <v-card-title>
            <v-icon
                large
                left
            >
              mdi-file-edit
            </v-icon>
            <span>แต่งตั้งคณะกรรมการ</span>
          </v-card-title>

          <v-card-text class="headline font-weight-bold">
          </v-card-text>

          <v-card-actions class="justify-space-around">
            <v-row
                class="justify-space-around"
            >
              <v-col align="center" col="12" md="12">
                <v-btn
                    text
                    v-for="menu in Menu"
                    :key="menu.id"
                    @click="goToPage(menu.page)">
                  <span>{{ menu.value }}</span>
                </v-btn>
                <hr/>
              </v-col>
            </v-row>
          </v-card-actions>

          <router-view></router-view>

        </v-card>
        <div class="d-none d-print-block">
          <router-view></router-view>
        </div>
      </v-container>
      <v-dialog
        v-model="dialogLoading"
        persistent
        width="300"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-text>
          Loading...
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </template>
  </v-content>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Const from "@/const/Const";

export default {
  name: "Appointment",
  data() {
    return {
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      CheckAdmin: false,
      CheckSubAdmin: false,
      dialogLoading: false,
      Menu: [
        {
          id: '1',
          value: 'คณะกรรมการ',
          page: '/Appointment/ManageAppointment'
        },
        {
          id: '2',
          value: 'แต่งตั้งคณะกรรมการ',
          page: '/Appointment/InsertAppointment'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      projectRegData: 'Project/getProjectReg',
      JoinProject: 'Project/getJoinProject',
      ProjectRound: 'Project/getProjectRound',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initProjectRegister: 'Project/initProjectRegister',
      getProjectRoundData: 'Project/getProjectRoundData',
      initProjectRoundData: 'Project/initProjectRoundData',
      initJoinProject: 'Project/initJoinProject',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',

    }),
    init: function () {
      this.getMenuPermissData().then(res => {
        if (res) {
          if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '11' && item.page_status == '1').length > 0) {
            this.maintain = false
            this.getPermissionData({
              perid: this.MeData[0].perid
            }).then(resAdmin => {
              if (resAdmin) {
                this.PermissionAdmin.map((Per_i, idx) => {
                  if (Per_i.permission_id == '11000') {
                    this.dialogLoading = false
                    this.CheckAdmin = true
                    // Code here ..
                  } else {
                    if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                      this.dialogLoading = false
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.getPermissionUserData({
                  perid: this.MeData[0].perid
                }).then(resUser => {
                  if (resUser) {
                    this.Permission.map((Per_i, idx) => {
                      if (Per_i.permission_id == '11000') {
                        this.dialogLoading = false
                        this.CheckSubAdmin = true
                        // Code here ..
                      } else {
                        if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                          this.dialogLoading = false
                          this.$router.push('/')
                        }
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.CheckSubAdmin = false
                    this.CheckAdmin = false
                    this.$router.push('/')
                  }
                })
              }
            })
          } else {
            this.maintain = true
          }
        }
      }).then(err => {
        if (err) {
          this.maintain = true
        }
      })
    },
    goToPage: function (page) {
      this.$router.push(page)
    }
  },
  mounted() {
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    this.dialogLoading = true
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '11'
        })
        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '11' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                this.init()
            } else {
              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '11' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '11')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
              this.dialogLoading = false
            }
          }
        }).then(err => {
          if (err) {
            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '11' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '11')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
            this.dialogLoading = false
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>

</style>
